/** Who sees the top-level Analytics section while it is in development. */
const ANALYTICS_SECTION_EMAILS: ReadonlySet<string> = new Set([
  "aradford@getredo.com",
  "dev@getredo.com",
  "jp@redo.com",
  "ross@redo.com",
  "tyler.hawkins@redo.com",
  "will.schaefermeyer@getredo.com",
]);

export function canSeeAnalyticsSection(email: string | undefined): boolean {
  return !!email && ANALYTICS_SECTION_EMAILS.has(email.toLowerCase());
}
